/*jslint browser */
/*global process */

var $ = jQuery;
declare var document: any;

/**
 *
 */
export default class ProductGridController
{
    private _gridColourBox: JQuery;
    private _filterValues: JQuery;
    private _attachmentWoocommerceThumbnail: JQuery;
    private _gridImageContainer: JQuery;

    constructor()
    {

    }

    public gridAction(): void
    {
        this.registerEvents();
        this.setFilter();

        const ob = this;
        $(document).ajaxComplete(function() {
            ob.registerEvents();
        });
    }

    /**
     *
     * @private
     */
    private registerEvents(): void
    {
        this._gridColourBox = $('.grid-colour-box');
        this._filterValues = $('.filter-values');
        this._attachmentWoocommerceThumbnail = $('.attachment-woocommerce_thumbnail');
        this._gridImageContainer = $('.grid-image-container');

        this._gridColourBox.on('click', (e) => {
            this.colourBoxClick($(e.currentTarget));
        })

        /*this._attachmentWoocommerceThumbnail.on('mouseover', (e) => {
            this.toggleImage($(e.currentTarget), 'on');
        })
        this._attachmentWoocommerceThumbnail.on( "mouseout", (e) => {
            this.toggleImage($(e.currentTarget), 'off');
        } );*/

        this._gridImageContainer.on('mouseover', (e) => {
            this.toggleImage($(e.currentTarget).find('.attachment-woocommerce_thumbnail'), 'on');
        })
        this._gridImageContainer.on( "mouseout", (e) => {
            this.toggleImage($(e.currentTarget).find('.attachment-woocommerce_thumbnail'), 'off');
        } );
    }

    private colourBoxClick(ob: JQuery): void {
        const src = ob.data('img');

        if(src != '') {
            const img = ob.parents('.eszlwcf-product').find('.eszlwcf-product-thumbnail').prop('src', src);
            const img2 = ob.parents('.xt-eszlwcf-product').find('.eszlwcf-product-thumbnail').prop('src', src);
            //const img3 = ob.parents('.type-product').find('.attachment-woocommerce_thumbnail').prop('src', src);
            const img31 = ob.parents('.type-product').find('.attachment-woocommerce_thumbnail').prop('srcset', src);
        }
    }

    private toggleImage(ob: JQuery, type: string): void {
        let src;
        if(type == 'on') {
            src = ob.parents('.type-product:first').find('.second-image').data('simg');
        } else {
            src = ob.prop('src');
        }

        if(src != '' && src != undefined) {
            const img31 = ob.parents('.type-product:first').find('.attachment-woocommerce_thumbnail').prop('srcset', src);
        }
    }

    private setFilter() {
        if(this._filterValues) {
            const checkbox = $('.'+this._filterValues.data('key')+'-filter-box').find('input[value="'+this._filterValues.val()+'"]');
            setTimeout(() => {
                checkbox.prop('checked', true);
                checkbox.trigger('change');
            }, 200);
        }
    }
}